// T2T-05-C3-UI — Single attachment chip rendered inside a message row.

import React from "react";
import PropTypes from "prop-types";

function iconForMime(mime) {
  if (!mime) return "bi-paperclip";
  if (mime.startsWith("image/")) return "bi-file-earmark-image";
  if (mime.includes("pdf")) return "bi-file-earmark-pdf";
  if (mime.includes("excel") || mime.includes("spreadsheet")) return "bi-file-earmark-excel";
  if (mime.includes("word") || mime.includes("document")) return "bi-file-earmark-word";
  return "bi-file-earmark";
}

function formatSize(bytes) {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export default function AttachmentChip({ attachment, onOpen }) {
  const scanning = attachment.scan_status === "pending";
  const infected = attachment.scan_status === "infected";
  const errored  = attachment.scan_status === "error";

  return (
    <button
      type="button"
      onClick={onOpen}
      disabled={scanning || infected || errored}
      title={
        infected ? "File flagged by virus scan"
          : errored ? "Scan failed — try re-uploading"
          : scanning ? "Scanning…"
          : `Download ${attachment.filename}`
      }
      style={{
        display: "inline-flex", alignItems: "center", gap: 6,
        background: "var(--t2t-bg)",
        border: "1px solid var(--t2t-border)",
        borderRadius: "var(--t2t-radius)",
        padding: "4px 8px",
        fontSize: 11,
        color: "var(--t2t-text-primary)",
        cursor: (scanning || infected || errored) ? "not-allowed" : "pointer",
        opacity: (scanning || infected || errored) ? 0.55 : 1,
      }}
    >
      <i className={`bi ${iconForMime(attachment.mime_type)}`} style={{ fontSize: 13 }} />
      <span style={{ maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {attachment.filename}
      </span>
      <span style={{ color: "var(--t2t-text-muted)" }}>
        {formatSize(attachment.file_size)}
      </span>
      {scanning && <i className="bi bi-shield-shaded" title="Scanning" />}
      {infected && <i className="bi bi-shield-exclamation" style={{ color: "var(--t2t-danger)" }} />}
      {errored  && <i className="bi bi-exclamation-circle"  style={{ color: "var(--t2t-warning)" }} />}
    </button>
  );
}

AttachmentChip.propTypes = {
  attachment: PropTypes.object.isRequired,
  onOpen:     PropTypes.func.isRequired,
};
